import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class PositionService {

  constructor(
  			      private http: HttpClient,
  			      private global: GlobalDataService	
  			     ) { }


   getPosition(isActive:number=-1) {  

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl+"positions"+isAvailable);
   }

   getPositionById(id: any) {
        return this.http.get(this.global.httpUrl+"positions/"+id);
   } 

   createPosition(data: any){
        return this.http.post(this.global.httpUrl+"positions", data); 

    }

   updatePosition(data: any,id: any){
        return this.http.put(this.global.httpUrl+"positions/"+id, data); 
    }
					
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/positions/position.service.ts